export const replaceNaeringUrltag = (str: string) => {
  if (str.match(/naeringvest/)) return 'vest';
  return str;
};
